import { Grid, IconButton } from "@material-ui/core";
import { ChevronRight, ChevronLeft } from "@material-ui/icons";
import React from "react";
import { LEFT, RIGHT } from "../ItemCardModal";

interface ICarouselArrow {
  onClick: Function;
  focusIndex: number;
  direction: number;
}

const CarouselArrow = ({ onClick, focusIndex, direction }: ICarouselArrow) => {
  return (
    <Grid
      container
      style={{
        height: "100%",
        width: 50,
        position: "absolute",
        left: direction === LEFT ? 5 : "",
        right: direction === RIGHT ? 5 : "",
        top: 0,
        zIndex: 4,
      }}
      justifyContent={direction === RIGHT ? "flex-end" : "flex-start"}
      alignItems="center">
      <Grid item>
        <IconButton
          onClick={() => onClick(focusIndex)}
          style={{ color: "white", backgroundColor: "rgba(30, 30, 30, 0.36)" }}>
          {direction === RIGHT && <ChevronRight />}
          {direction === LEFT && <ChevronLeft />}
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default CarouselArrow;
